import React from 'react'
import accounting from 'accounting'

const decimalPlaces = 0
const exponent = Math.pow(10, decimalPlaces)

export const moneyRound = (amount, round = false) =>
  round
    ? Math.round(amount * exponent) / exponent
    : Math.ceil(amount * exponent) / exponent

// for explanation visit - https://stackoverflow.com/a/14428340/1725462
export const moneyFormat = (amount: number) => (
  <span style={{whiteSpace: 'nowrap'}}>
    {accounting.formatMoney(amount, {
      symbol: 'Kč',
      decimal: ',',
      precision: 0,
      thousand: ' ',
      format: '%v %s'
    })}
  </span>
)



// WEBPACK FOOTER //
// ./src/utils/format.tsx